import { velocityPerSecond } from 'motion-utils';
var velocitySampleDuration = 5; // ms

function calcGeneratorVelocity(resolveValue, t, current) {
  var prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

export { calcGeneratorVelocity };